import { render, staticRenderFns } from "./OrderBuy.vue?vue&type=template&id=0dc23f4f&scoped=true&"
import script from "./OrderBuy.vue?vue&type=script&lang=js&"
export * from "./OrderBuy.vue?vue&type=script&lang=js&"
import style0 from "./OrderBuy.vue?vue&type=style&index=0&id=0dc23f4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc23f4f",
  null
  
)

export default component.exports